import { forwardRef, useRef } from "react";
import { getObjectValue, hasProperty } from "../utils/commonUtilityFunctions";
// import has from "lodash/has";
import format from "date-fns/format";
import QRCode from "qrcode.react";
import { Button, Container } from "@cti-workspace/ui";
import { JSONParse } from "@cti-workspace/helpers";
import { TypographyH4, TypographyH5 } from "../VerifierPageComponents/Typography";

const SimpleCert = forwardRef(({ document, config, isFullScreen = false, onClose = () => { }, onZoom = () => { }, setCertBgImg = () => { } }, ref) => {
	let dateIssued;

	try {
		dateIssued = format(new Date(getObjectValue(document, "issuedOn")), "PPP");
    setCertBgImg(getObjectValue(config, "bgImage", "https://cti3.s3.us-east-1.amazonaws.com/prod/blue-rays.png"));
	} catch (error) {
		console.error(getObjectValue(document, "issuedOn", `${new Date().toString()}`));
		dateIssued = format(new Date(), "PPP");
	}

	return (
		<div style={{ position: "relative" }}>
			<Container
				// component={Box}
				maxWidth="lg"
				disableGutters={true}
				className="certificate"
				ref={ref}
				style={
					hasProperty(config, "gradient")
						? {
							height: isFullScreen ? "90vh" : "auto",
							background: `${getObjectValue(config, "gradient")}`,
							backgroundPosition: "center",
							backgroundSize: "cover",
							backgroundRepeat: "no-repeat",
							// border: "10px solid #324353",
							overflow: "hidden",
							position: "relative",
						}
						: {
							height: isFullScreen ? "90vh" : "auto",
              backgroundImage: `url('${getObjectValue(config, "bgImage", "https://cti3.s3.us-east-1.amazonaws.com/prod/blue-rays.png")}')`,
							backgroundPosition: "center",
							backgroundSize: `99% 99%`,
							backgroundRepeat: "no-repeat",
							// border: "10px solid #324353",
							overflow: "hidden",
							position: "relative",
						}
				}>
				<div
					style={{
						marginTop: "auto",
						marginBottom: "auto",
						transform: isFullScreen ? "scale(0.96)" : "scale(0.8)",
						display: "flex",
						flexDirection: "column",
						justifyContent: "space-between",
						gap: "24px"
					}}>
					<div style={{ height: "20%", textAlign: "center" }}>
						<img alt="badge" style={{ maxHeight: "15vh", aspectRatio: "1:1" }} src={getObjectValue(document, "additionalData.imageUrl")} />
					</div>
					<div style={{ textAlign: "center" }}>
						<TypographyH5 style={{ color: "#3f51b5", textAlign: "center", ...JSONParse(getObjectValue(config, "text1", "{}")).value }}>
							<i>This is to certify that</i>
						</TypographyH5>
					</div>
					<div style={{ textAlign: "center" }}>
						<TypographyH4 style={{ textAlign: "center", ...JSONParse(getObjectValue(config, "text2", "{}")).value }}>
							{getObjectValue(document, "recipient.name")}
						</TypographyH4>
					</div>
					<div style={{ textAlign: "center" }}>
						<TypographyH5 style={{ color: "#3f51b5", textAlign: "center", ...JSONParse(getObjectValue(config, "text1", "{}")).value }}>
							<i>{getObjectValue(config, "textContent1", "has successfully completed the")}</i>
						</TypographyH5>
					</div>
					<div style={{ textAlign: "center" }}>
						<TypographyH4 style={{ textAlign: "center", ...JSONParse(getObjectValue(config, "text2", "{}")).value }}>
							{getObjectValue(document, "name")}
						</TypographyH4>
						{/* <Typography variant="body1" color="primary" align="center">
							<i>{get(document, "additionalData.description")}</i>
						</Typography> */}
					</div>
					<div style={{ textAlign: "center" }}>
						<TypographyH5 style={{ color: "#3f51b5", textAlign: "center", ...JSONParse(getObjectValue(config, "text1", "{}")).value }}>
							<i>{getObjectValue(config, "textContent2", "Certification through training administered by")}</i>
						</TypographyH5>
					</div>
					<div style={{ textAlign: "center" }}>
						<img
							alt="issuer logo"
							style={{
								height: "auto",
								maxHeight: "20vh",
								maxWidth: "80%",
							}}
							src={getObjectValue(document, "additionalData.issuerImageUrl")}
						/>
					</div>
					<div style={{ height: "20%", textAlign: "center" }}>
						<TypographyH5 style={{ color: "#3f51b5", textAlign: "center", ...JSONParse(getObjectValue(config, "text1", "{}")).value }}>
							<i> Issued on : {dateIssued}</i>
						</TypographyH5>
					</div>
				</div>

				{/* {document.additionalDataMain.shortURLs && (
					<div className="print-source">
						<QRCode value={document.additionalDataMain.shortURLs.publicUrl || ""} />
					</div>
				)} */}
			</Container>
			{/* {isFullScreen ? (
				<span style={{ position: "absolute", zIndex: 1, right: 10, top: 10 }}>
					<Button
						buttonType="icon"
						color={"white"}
						icon="cancel-circle"
						iconStyle={{ weight: "fill", color: "#C0C0C0" }}
						noBorder={true}
						borderRadius={"50%"}
						buttonStyle={{ padding: 0, backgroundColor: "transparent" }}
						iconSize="2rem"
						onClick={(e) => {
							e?.stopPropagation();
							onClose();
						}}
					/>
				</span>
			) : (
				<span style={{ position: "absolute", zIndex: 1, right: 10, bottom: 10 }}>
					<Button
						buttonType="icon"
						color={"white"}
						icon="arrowsOut"
						iconStyle={{ weight: "fill", color: "#C0C0C0" }}
						noBorder={true}
						borderRadius={"50%"}
						buttonStyle={{ padding: 0, backgroundColor: "transparent" }}
						iconSize="1.5rem"
						onClick={(e) => {
							e?.stopPropagation();
							onZoom();
						}}
					/>
				</span>
			)} */}
		</div>
	);
});

export default SimpleCert;
